import React from 'react';
import PropTypes from 'prop-types';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
// Components
import Spinner from '../SpinnerComponent';
var Loader = function Loader(_ref) {
  var className = _ref.className,
    style = _ref.style,
    id = _ref.id;
  return /*#__PURE__*/React.createElement("div", {
    className: "full-width full-height flex-center ".concat(className),
    style: style
  }, /*#__PURE__*/React.createElement(Spinner, {
    id: id
  }));
};
Loader.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  id: PropTypes.string
};
Loader.defaultProps = {
  className: '',
  style: EMPTY_OBJECT,
  id: ''
};
export default Loader;